import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'portfolio/Scan 37.jpeg' satisfies MediaPath
const traffic = 'portfolio/Scan 21.jpeg' satisfies MediaPath
const s27 = 'portfolio/Scan 27.jpeg' satisfies MediaPath
const s28 = 'portfolio/Scan 28.jpeg' satisfies MediaPath
const s33 = 'portfolio/Scan 33.jpeg' satisfies MediaPath
const s34 = 'portfolio/Scan 34.jpeg' satisfies MediaPath
const s40 = 'portfolio/Scan 40.jpeg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'ephemera',
	name: 'Ephemera',
	excerpt: 'A paper trail — scanned, arranged, kept',
	tags: ['collage', 'print'],
	cover,
	order: 15,
}

export default function Ephemera() {
	return (
		<>
			<p>
				The residue of getting from one place to another: regatta bib numbers, ticket stubs,
				receipts, race cards, a long-exposure of headlights on a highway. Scanned flat and arranged
				as found — composition by accumulation rather than design.
			</p>
			<Gallery
				items={[
					{ src: cover, alt: 'Race bibs and ticket stubs' },
					{ src: traffic, alt: 'Traffic — long exposure' },
					{ src: s27, alt: 'Documents and tickets' },
					{ src: s28, alt: 'Regatta instructions' },
					{ src: s33, alt: 'Cards and notes' },
					{ src: s34, alt: 'Bibs and tickets' },
					{ src: s40, alt: 'Bib numerals' },
				]}
			/>
		</>
	)
}
